<template>
  <el-row>
    <template v-if="showNewContent">
      <app-seccion></app-seccion>
    </template>
    <template v-else>
      <el-card class="box-card">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }">Panel</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db + '/pages'}">Páginas</el-breadcrumb-item>
          <el-breadcrumb-item v-if="$route.params.id">Editando: {{form.title}}</el-breadcrumb-item>
          <el-breadcrumb-item v-else-if="form.title">Nueva página: {{form.title}}</el-breadcrumb-item>
          <el-breadcrumb-item v-else>Nueva página</el-breadcrumb-item>
        </el-breadcrumb>
        <br />
        <h2>{{form.title}}</h2>
        <el-form @submit.native.prevent="submit" ref="form" label-position="top" id="form">
          <el-row type="flex" justify="space-between">
            <el-col :span="7">
              <el-form-item label="Título">
                <el-input
                  v-model="form.title"
                  type="text"
                  placeholder="Título"
                  name="title"
                  id="title"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="URL">
                <el-input v-model="form.url" type="text" placeholder="url" name="url" id="url"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="Tipo de menú">
                <select
                  v-model="form.menu_id"
                  placeholder="Selecciona uno tipo de menú"
                  name="menu_id"
                  class="select"
                >
                  <option v-for="(item, i) in menu" :key="i" :value="item.id">{{item.menu}}</option>
                </select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="¿Visible?">
                <el-switch
                  v-model="form.visible"
                  placeholder="'Visible'"
                  name="visible"
                  :active-value="'1'"
                  :inactive-value="'2'"
                ></el-switch>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="Texto, en caso de que no haya ningún escritorio">
                <vue-editor v-model="form.texto" :editorToolbar="customToolbar"></vue-editor>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item>
                <button type="submit" class="el-button el-button--primary">
                  <span>Guardar</span>
                </button>
                <el-button @click="cancelar()">Cancelar</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
      <br />
      <el-card class="box-card" v-if="showMenu">
        <h2>Menú</h2>
        <!-- componente modal para ordernar listado -->
        <app-modal-draggable
          v-if="modalDraggable"
          :content="tablaDatos"
          :name="'title'"
          :table="'sections'"
        ></app-modal-draggable>
        <!-- componente modal enlazar contenido a otro contenido en el menú -->
        <app-modal-content-link
          v-if="modalContentLink"
          :link="modalContentLink"
          :content="tablaDatos"
          :name="'title'"
          table="section_sections"
          row="parent_content_id"
        ></app-modal-content-link>
        <!-- componente tabla -->
        <app-table-paginate
          v-if="tablaDatos.length > 0"
          class="my-3"
          :routeEdit="routeEdit"
          :tableQuery="tablaDatos"
          :tableColumns="tableColumns"
          :preview="preview"
          :desktop="true"
          :search="true"
          :draggable="true"
          :link="true"
          :duplicate="true"
          :move="move"
        ></app-table-paginate>
        <button @click="addContend()" class="el-button el-button--primary">
          <span>Añadir sección</span>
          <i class="el-icon-circle-plus"></i>
        </button>
      </el-card>
    </template>
  </el-row>
</template>

<script>
import ApiService from "@/common/api.service";
import { mapActions, mapGetters, mapState } from "vuex";
import { FECTH_TIPO_MENU, FECTH_TEMPLATE_OPTIONS } from "@/store/actions.type";
import { SET_TIPO_MENU, SET_TEMPLATE_OPTIONS } from "@/store/mutations.type";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import { INTRANET_URL } from "@/common/config";
import seccion from "@/components/Dashboard/pages/seccion";
import Draggable from "@/components/Dashboard/Modals/draggable";
import ContentLink from "@/components/Dashboard/Modals/contentLink";
import { VueEditor } from "vue2-editor";

export default {
  name: "editForm",
  components: {
    "app-seccion": seccion,
    "app-table-paginate": tablaConPaginador,
    "app-modal-draggable": Draggable,
    "app-modal-content-link": ContentLink,
    VueEditor
  },
  created() {
    this.showMenu = false;
    this.getOptionsMenu();
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.init();
      setTimeout(() => {
        this.routeEdit =
          "/dashboard/" +
          this.$route.params.db +
          "/pages/" +
          this.id +
          "/seccion/";
        //this.preview = INTRANET_URL + "/modulo/" + this.form.url + "/";
      }, 300);
    }
    this.$root.$on("delete", id => this.eliminarRegistroSeccion(id));
    this.$root.$on("desktop", (id, row, value) =>
      this.updateDesktop(row, value)
    );
    this.$root.$on("volver_a_páginas", a => (this[a] = !this[a]));

    this.$root.$on("duplicate", e => this.duplicate(e));
    this.$root.$on("draggable", e => this.showDraggable());
    this.$root.$on("link-content", id => this.showLinkContent(id));
    this.$root.$on("closeModal", () => this.closeModal());
  },
  data() {
    return {
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["link", "formula"],
        [{ direction: "rtl" }]
      ],
      tableColumns: [
        {
          label: "Título",
          prop: "title"
        },
        {
          label: "URL",
          prop: "url"
        },
        {
          label: "Icono",
          prop: "icon"
        },
        {
          label: "Escritorio",
          prop: "desktop"
        },
        {
          label: "Submenu",
          prop: "submenu"
        }
      ],
      form: {
        title: null,
        menu_id: 0,
        url: null,
        texto: null,
        visible: 1
      },
      formOld: {
        title: null,
        menu_id: 0,
        url: null,
        texto: null,
        visible: 1
      },
      routeEdit: null,
      preview: null,
      menu: false,
      content: [],
      showNewContent: false,
      showMenu: false,
      id: null,
      existUrl: true,
      modalDraggable: false,
      modalContentLink: false,
      move: true
    };
  },
  methods: {
    init() {
      // this.fecthPaginaActive()
      this.getPage();
      this.getContent();
    },
    async getPage() {
      const a = await ApiService.post("dashboard/table", {
        table: "pages",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.id
      });
      console.log(a);
      this.form = a.data;
      this.preview = INTRANET_URL + "/modulo/" + this.form.url + "/";
      this.formOld = a.data;
      this.showMenu = true;
    },
    async getContent() {
      this.content = [];

      const a = await ApiService.post("dashboard/setsections", {
        table: "sections",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.id
      });

      if (a.data !== "Algo ha fallado") {
        this.content = a.data.map(element => {
          element.desktop == 1
            ? (element.desktop = "Sí")
            : (element.desktop = "No");
          const b = this.sectionContent(a).then(response => {
            if (response.data !== "Algo ha fallado") {
              response.data.map(e => {
                if (e.content_id === element.id) {
                  a.data.map(title =>
                    title.id === e.parent_content_id
                      ? (element.submenu = title.title)
                      : false
                  );
                }
              });
            }
          });
          element.move =
            "/dashboard/" +
            this.$route.params.db +
            "/form/edit/sections/" +
            element.id;
          return element;
        });
        this.content.sort(function(a, b) {
          return a.order_row - b.order_row;
        });
        this.showMenu = true;
      }
    },
    async sectionContent(a) {
      return await ApiService.post("dashboard/table", {
        table: "section_sections",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: a.id,
        row: "content_id"
      });
    },
    async getOptionsMenu() {
      await this.$store
        .dispatch(FECTH_TIPO_MENU)
        .then(response => (this.menu = response));
    },

    async formUrlNoExist(value, table = "pages") {
      const a = await ApiService.post("dashboard/chechUrl", {
        table: table,
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        url: value ? value : this.form.url
      });

      if (a.data) {
        this.$message.error({
          message: "La url introducida ya está en uso"
        });
        this.existUrl = true;
      } else {
        this.existUrl = false;
      }
    },
    async submit() {
      if (this.$route.params.id && this.form.url == this.formOld.url) {
        this.existUrl = false;
      } else {
        this.formUrlNoExist();
      }
      setTimeout(() => {
        if (this.existUrl == false) {
          if (this.form.title == "" || this.form.title == null) {
            this.$message({
              type: "error",
              message: "El campo título es obligatorio"
            });
            return false;
          }
          if (this.form.url == "" || this.form.url == null) {
            this.$message({
              type: "error",
              message: "El campo url es obligatorio"
            });
            return false;
          }
          if (this.form.menu_id == 0) {
            this.$message({
              type: "error",
              message: "Tienes que seleccionar un tipo de menú válido"
            });
            return false;
          }

          const a = this.editForm().then(a => {
            if (a.data) {
              this.$notify({
                title: "Modificado",
                message: "Se ha modifcado la entrada con éxito",
                type: "success"
              });
              this.updateUsuarioPermisos(a.data);
              setTimeout(() => {
                this.showMenu = true;
                let id;
                this.id == null ? (id = a.data) : (id = this.id);

                this.updateUsuarioPermisos(id);

                this.$router.replace(
                  "/dashboard/" + this.$route.params.db + "/pages/edit/" + id
                );
                // this.$router.replace('/dashboard/' + this.$route.params.db + '/pages/'+ this.$route.params.page +'/section/' + id)
                this.init();
              }, 1500);
            } else {
              this.$notify.error({
                title: "Fallo",
                message: "Ago ha fallodo y no se ha modificado la entrada"
              });
            }
          });
        }
      }, 300);
    },
    async editForm() {
      this.form.texto += " ";

      return await ApiService.post("dashboard/editform", {
        table: "pages",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.form,
        id: this.$route.params.id
      });
    },
    addContend() {
      this.showNewContent = !this.showNewContent;
    },
    async eliminarRegistroSeccion(id) {
      const a = await ApiService.post("dashboard/delete", {
        table: "sections",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: id
      });

      this.deleterow = a.data;
      setTimeout(() => {
        this.$message({
          type: "success",
          message: "Se ha eliminado correctamente"
        });
        this.showMenu = false;
        this.getContent();
        setTimeout(() => {
          this.showMenu = true;
        }, 1500);
      }, 500);
    },
    async updateDesktop(row, value) {
      const a = await ApiService.put("dashboard/update-page-desktop", {
        table: "sections",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: row.id,
        value: value
      });
      // this.deleterow = response.data
      setTimeout(() => {
        this.showMenu = false;
        this.getContent();
        setTimeout(() => {
          this.showMenu = true;
        }, 1500);
      }, 1000);
    },
    async duplicate(e) {
      const title = prompt("Título", e.title);
      const url = prompt("URL", e.url);
      await this.formUrlNoExist(url, "sections");

      if (!this.existUrl) {
        let form = {
          id: e.id,
          desktop: e.desktop,
          title: title,
          menu_id: e.menu === "Vertical" ? 1 : 2,
          url: url,
          icon: e.icon
        };

        const a = await ApiService.post("dashboard/duplicate-section", {
          table: "pages",
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
          form: form,
          id: this.$route.params.id
        });
        if (a.data) {
          this.$notify({
            title: "Modificado",
            message: "Se ha duplicado la página con éxito",
            type: "success"
          });
          setTimeout(() => {
            this.getContent();
          }, 500);
        } else {
          this.$notify.error({
            title: "Fallo",
            message: "Ago ha fallodo y no se ha duplicado la página"
          });
        }
      }
    },

    cancelar() {
      this.$router.replace("/dashboard/" + this.$route.params.db + "/pages");
    },
    showDraggable() {
      this.modalDraggable = true;
    },
    showLinkContent(id) {
      this.modalContentLink = id;
    },
    closeModal() {
      this.modalDraggable = false;
      this.modalContentLink = false;
      this.init();
    },

    async updateUsuarioPermisos(id) {
      // busco los usuarios con permiso admin
      await ApiService.post("admin/users", {
        token: localStorage.getItem("token"),
        project: localStorage.getItem("table")
      }).then(r => {
        r.data.map(e => {
          console.log(e);
          if (e.level == "admin") {
            ApiService.post("admin/user-access", {
              token: localStorage.getItem("token"),
              project: localStorage.getItem("table"),
              id: e.id
            }).then(response => {
              let access_tables = response.data.access_tables;
              let access_components = JSON.parse(
                response.data.access_components
              );
              let gestor_usuarios = response.data.gestor_usuarios;
              let value = access_components[1]["value"];
              if (value.indexOf(id) == -1) {
                value.push(id.toString());
                access_components[1]["value"] = value;
                ApiService.post("admin/update-user-access", {
                  token: localStorage.getItem("token"),
                  project: localStorage.getItem("table"),
                  id: e.id,
                  access_tables: access_tables,
                  access_components: JSON.stringify(access_components),
                  gestor_usuarios: gestor_usuarios
                });
              }
            });
          }
        });
      });
    }
  },
  computed: {
    tablaDatos() {
      return this.content;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/pages/form.vue